(() => {
  if (window.shieldCartUpsellsInitialized) return;
  window.shieldCartUpsellsInitialized = true;
  let adding = false;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('cart-drawer .sd-upsell__add[data-variant-id]');
    if (!button) return;
    event.preventDefault();
    const drawer = button.closest('cart-drawer');
    if (adding || button.disabled || drawer.querySelector('.cart__items--disabled')) return;
    const variantId = button.dataset.variantId;
    if (!/^\d+$/.test(variantId)) return;

    const label = button.textContent;
    const errors = drawer.querySelector('#CartDrawer-CartErrors');
    if (errors) errors.textContent = '';
    adding = true;
    button.disabled = true;
    button.textContent = 'Adding…';
    button.setAttribute('aria-busy', 'true');
    const cartItems = drawer.querySelector('#CartDrawer-CartItems');
    cartItems?.classList.add('cart__items--disabled');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          // Deliberately omit selling_plan: every recommendation is a one-time purchase.
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
      }
      // A successful add is never repeated if its returned HTML is missing.
      await drawer.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shield-cart-upsell' });
      }
    } catch (error) {
      const currentErrors = drawer.querySelector('#CartDrawer-CartErrors');
      if (currentErrors) currentErrors.textContent = error.message || 'Unable to add this item. Please try again.';
    } finally {
      adding = false;
      button.disabled = false;
      button.textContent = label;
      button.removeAttribute('aria-busy');
      cartItems?.classList.remove('cart__items--disabled');
      drawer.querySelector('#CartDrawer-CartItems')?.classList.remove('cart__items--disabled');
    }
  });
})();
